/* Structural layout plus the scene's own illustration palette. Each time-of-day
   class sets the scene colours and re-points Astryx's text and button tokens so
   the stock components read on that sky (all at least 4.5:1). The scene is an
   illustration, so it looks the same in light and dark mode. */

/* The scene is absolutely positioned, so only the content participates in this
   flex column — which centers it against the card's full height. */
.card {
  position: relative;
  min-height: 232px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  --color-text-primary: var(--greeting-ink);
  --color-text-secondary: var(--greeting-ink-secondary);
}

.scene {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.content {
  position: relative;
}

.sky {
  fill: var(--greeting-sky);
}

.moonShadow {
  fill: var(--greeting-sky);
}

.sun {
  fill: var(--greeting-sun);
}

.star {
  fill: var(--greeting-sun);
}

.hillFar {
  fill: var(--greeting-hill-far);
}

.hillNear {
  fill: var(--greeting-hill-near);
}

/* The primary button inverts against the sky: ink fill, sky label. */
.action {
  --color-accent: var(--greeting-ink);
  --color-on-accent: var(--greeting-sky);
  --color-overlay-hover: color-mix(in srgb, var(--greeting-sky) 12%, transparent);
  --color-overlay-pressed: color-mix(in srgb, var(--greeting-sky) 24%, transparent);
}

.morning {
  --greeting-sky: #faeeda;
  --greeting-sun: #ef9f27;
  --greeting-hill-far: #f0997b;
  --greeting-hill-near: #d85a30;
  --greeting-ink: #412402;
  --greeting-ink-secondary: #854f0b;
}

.afternoon {
  --greeting-sky: #b5d4f4;
  --greeting-sun: #fac775;
  --greeting-hill-far: #5dcaa5;
  --greeting-hill-near: #1d9e75;
  --greeting-ink: #042c53;
  --greeting-ink-secondary: #0c447c;
}

.evening {
  --greeting-sky: #f4c0d1;
  --greeting-sun: #d85a30;
  --greeting-hill-far: #7f77dd;
  --greeting-hill-near: #3c3489;
  --greeting-ink: #4b1528;
  --greeting-ink-secondary: #72243e;
}

.night {
  --greeting-sky: #042c53;
  --greeting-sun: #e6f1fb;
  --greeting-hill-far: #0c447c;
  --greeting-hill-near: #26215c;
  --greeting-ink: #e6f1fb;
  --greeting-ink-secondary: #b5d4f4;
}

/* On phones the text spans the card; no sun can sit clear of it. */
@media (max-width: 480px) {
  .sun,
  .moonShadow {
    display: none;
  }
}

/* Forced colors flatten the sky under system-colored text; drop the scene. */
@media (forced-colors: active) {
  .scene {
    display: none;
  }
}
